import Plugin from '@ckeditor/ckeditor5-core/src/plugin'
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview'
import {icons} from '@ckeditor/ckeditor5-core'
import SourceEditing from "@ckeditor/ckeditor5-source-editing/src/sourceediting";

class NormalizeTextPlugin extends Plugin {

    lineBreak = 'HR4YOU_BR';
    paragraphOpen = 'HR4YOU_P_OPEN';
    paragraphClose = 'HR4YOU_P_CLOSE';

    init() {
        const editor = this.editor;
        const self = this;

        editor.ui.componentFactory.add('normalizeText', () => {

            const button = new ButtonView();
            button.set({
                label: 'Text normalisieren'
                    + ' (normalisiert den Textinhalt aus der Textbox für die weitere Bearbeitung mit dem CKEditor)',
                icon: icons.pencil,
                withText: false,
                tooltip: true,
                isEnabled: true
            });

            //disable button while editor is in SourceEditing mode
            button.listenTo(editor.ui, 'update', () => {
                const sourceEditing = editor.plugins.get('SourceEditing');
                if (sourceEditing instanceof SourceEditing) {
                    button.set({isEnabled: !sourceEditing.isSourceEditingMode});
                }
            });

            //button action
            button.on('execute', () => {

                //get current CK-Editor source-input
                var htmlInput = editor.data.get();

                htmlInput = self.clearInputAndKeepParagraphsAndLineBreaks(htmlInput);
                htmlInput = self.handleLineBreaks(htmlInput);
                htmlInput = self.handleParagraphs(htmlInput);

                //make action undoable
                editor.model.change(writer => {

                    // select whole content so it can be overwritten
                    editor.execute('selectAll');

                    //overwrite selection
                    const viewFragment = editor.data.processor.toView(htmlInput);
                    const modelFragment = editor.data.toModel(viewFragment);
                    editor.model.insertContent(modelFragment);

                });
            });

            return button;
        });
    };

    clearInputAndKeepParagraphsAndLineBreaks(htmlInput) {

        //keep linebreaks and paragraphs
        htmlInput = htmlInput.replace(/<p>/gim, this.paragraphOpen);
        htmlInput = htmlInput.replace(/<p [^>]*>/gim, this.paragraphOpen);

        htmlInput = htmlInput.replace(/<[\/]p>/gim, this.paragraphClose);
        htmlInput = htmlInput.replace(/<[\/]p [^>]*>/gim, this.paragraphClose);

        htmlInput = htmlInput.replace(/<br\s*[\/]?>/gim, this.lineBreak);

        //remove every tag
        htmlInput = htmlInput.replace(/<[^>]*>?/gim, '');

        return htmlInput;
    };

    handleLineBreaks(htmlInput) {
        const self = this;
        if (htmlInput.length > 0 && htmlInput.includes(this.lineBreak)) {
            let rawInputLines = htmlInput.split(this.lineBreak);
            htmlInput = "";
            rawInputLines.forEach(function (line, index) {
                if (line.length === 0) {
                    line = '&nbsp;';
                }
                if (line.includes(self.paragraphOpen)) {
                    htmlInput += line + self.getHtmlLinebreakIfNeeded(line);
                } else {
                    //CKEditor prefers paragraphs instead of linebreaks
                    htmlInput += '<p>' + line + '</p>';
                }
            });
        }
        return htmlInput;
    }

    handleParagraphs(htmlInput) {
        htmlInput = htmlInput.replaceAll(this.paragraphOpen, '<p>');
        htmlInput = htmlInput.replaceAll(this.paragraphClose, '</p>');
        return htmlInput;
    }

    getHtmlLinebreakIfNeeded(line) {
        //try to avoid unnecessary additional linebreaks
        let regexParagraphsOpen = new RegExp(this.paragraphOpen, "g")
        let regexParagraphsClose = new RegExp(this.paragraphClose, "g")

        let countParagraphsOpen = (line.match(regexParagraphsOpen) || []).length;
        let countParagraphsClose = (line.match(regexParagraphsClose) || []).length;

        let append = '<br>';
        if (countParagraphsOpen < countParagraphsClose) {
            append = '';
        }

        return append;
    }
}

export {
    NormalizeTextPlugin
}
